// extracted by mini-css-extract-plugin
export var actionButton = "_sp-0";
export var actionMenuContainer = "_sp-i";
export var bubble = "_sp-2";
export var bubbleActionMenu = "_sp-j";
export var bubbleContext = "_sp-6";
export var bubbleItems = "_sp-7";
export var customer = "_sp-3";
export var divider = "_sp-8";
export var fileList = "_sp-9";
export var hiddenComment = "_sp-o";
export var infoAbove = "_sp-a";
export var internal = "_sp-4";
export var lightActionButton = "_sp-1";
export var link = "_sp-b";
export var merchant = "_sp-5";
export var message = "_sp-c";
export var profilePicture = "_sp-e";
export var quillToolbarContainer = "_sp-f";
export var senderDate = "_sp-g";
export var senderDateCustomer = "_sp-h";
export var senderName = "_sp-d";
export var time = "_sp-k";
export var uploadedImage = "_sp-l";
export var username = "_sp-m";
export var xsmall = "_sp-n";